<template src="./settings.html"></template>

<script>
import { ChiRhosNext, PaladinCoreStateHelpers } from '@paladin/core'
import { PaladinPropertyPreset, } from '@paladin/core-components'

const ChiRhosNextApi = new ChiRhosNext().api()

export default {
  page() {
    return {
      title: 'Tenant | Settings',
    }
  },
  components: { PaladinPropertyPreset },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      settings: {},
      model: {
        selectedTab: 'feeds',
      },
      editFeedForm: {
        name: '',
        title: 'Create Feed',
        order: 0,
        url: '',
        isHome: false,
        isImagesOnly: false,
        feeds: [],
        button: 'Create'
      },
      activeFeedCategory: null,
      activeFeed: null,
    }
  },
  computed: {
    ...PaladinCoreStateHelpers.userComputed,
    personPropertyPresets: function() {
      return this.settings != null ? this.settings.personPropertyPresets : null
    },

  },
  mounted() {
    this.initSettings()
  },
  methods: {
    initSettings() {
      if(this.isChiRhosOwner || this.isTenantOwner || this.isTenantAdmin)
      {
        ChiRhosNextApi.TenantApi.get()
          .then(
            (response) => {
              if(response.data && response.data.entity)
              {
                this.settings = response.data.entity
              }
              else
              {
                this.settings = {}
              }
            },
            (error) => {
              console.error(error)
              this.$toast(error, 'error')
            }
          )
      }
    },
    feedsTabSelected() {
      this.model.selectedTab = 'feeds'
      this.initFeedsTab()
    },
    initFeedsTab()
    {

    },
    saveFeedSubmit(evt) {
      evt.preventDefault();

      let _tenant = this.settings

      if(!_tenant.feeds) _tenant.feeds = [];

      if(!this.activeFeedCategory && !this.activeFeed)
      {
        // new top level

        _tenant.feeds.push({ name: this.editFeedForm.name, order: this.editFeedForm.order, isHome: this.editFeedForm.isHome, isImagesOnly: this.editFeedForm.isImagesOnly, url: this.editFeedForm.url });
      }
      else if(this.activeFeedCategory && !this.activeFeed)
      {
        // new child

        let activeCat = this.activeFeedCategory;

        let _cat = _tenant.feeds.filter(function(item) { return item && item.name === activeCat.name })[0]

        if(_cat)
        {
          if(!_cat.feeds) _cat.feeds = [];
          _cat.feeds.push({ name: this.editFeedForm.name, order: this.editFeedForm.order, isHome: this.editFeedForm.isHome, isImagesOnly: this.editFeedForm.isImagesOnly, url: this.editFeedForm.url });
        }
      }
      else if(!this.activeFeedCategory && this.activeFeed)
      {
        // update main

        let feed = this.activeFeed;

        let _cat = _tenant.feeds.filter(function(item) { return item && item.name === feed.name })[0]

        if(_cat)
        {
          _cat.name = this.editFeedForm.name
          _cat.order = this.editFeedForm.order
          _cat.isHome = this.editFeedForm.isHome
          _cat.isImagesOnly = this.editFeedForm.isImagesOnly
          _cat.url = this.editFeedForm.url
        }
      }
      else if(this.activeFeedCategory && this.activeFeed)
      {
        // update child

        let activeCat = this.activeFeedCategory;

        let _cat = _tenant.feeds.filter(function(item) { return item && item.name === activeCat.name })[0]

        if(_cat && _cat.feeds)
        {
          let activeChild = this.activeFeed;

          let _sub = _cat.feeds.filter(function(item) { return item && item.name === activeChild.name })[0]

          if(_sub)
          {
            _sub.name = this.editFeedForm.name
            _sub.order = this.editFeedForm.order
            _sub.isHome = this.editFeedForm.isHome
            _sub.isImagesOnly = this.editFeedForm.isImagesOnly
            _sub.url = this.editFeedForm.url
          }
        }
      }

      this.saveTenant('Feeds saved')
    },
    highlightsTabSelected() {
      this.model.selectedTab = 'highlights'
      this.initHighlightsTab()
    },
    initHighlightsTab()
    {

    },
    disclaimerTabSelected() {
      this.model.selectedTab = 'disclaimer'
      this.initDisclaimerTab()
    },
    initDisclaimerTab()
    {

    },
    personPresetsTabSelected() {
      this.model.selectedTab = 'personpresets'
      this.initPersonPresetsTab()
    },
    initPersonPresetsTab()
    {

    },
    showEditFeed(item)
    {
      this.editFeedForm.name = item.name
      this.editFeedForm.order = item.order
      this.editFeedForm.isHome = item.isHome
      this.editFeedForm.isImagesOnly = item.isImagesOnly
      this.editFeedForm.url = item.url
      this.editFeedForm.feeds = item.feeds
      this.activeFeedCategory = null
      this.activeFeed = item

      this.editFeedForm.title = 'Edit Feed'
      this.editFeedForm.button = 'Save'
    },
    showCreateFeed(item)
    {
      this.editFeedForm.name = ''
      this.editFeedForm.order = 0
      this.editFeedForm.isHome = false
      this.editFeedForm.isImagesOnly = false
      this.editFeedForm.url = ''
      this.editFeedForm.feeds = []
      this.activeFeedCategory = null
      this.activeFeed = null

      this.editFeedForm.title = 'Create Feed'
      this.editFeedForm.button = 'Create'
    },
    showCreateSubFeed(item)
    {
      this.editFeedForm.name = ''
      this.editFeedForm.order = 0
      this.editFeedForm.isHome = false
      this.editFeedForm.isImagesOnly = false
      this.editFeedForm.url = ''
      this.editFeedForm.feeds = []
      this.activeFeedCategory = item
      this.activeFeed = null

      this.editFeedForm.title = 'Create Child of ' + item.name
      this.editFeedForm.button = 'Create'
    },
    showEditSubFeed(cat, item)
    {
      this.editFeedForm.name = item.name
      this.editFeedForm.order = item.order
      this.editFeedForm.isHome = item.isHome
      this.editFeedForm.isImagesOnly = item.isImagesOnly
      this.editFeedForm.url = item.url
      this.editFeedForm.feeds = item.feeds
      this.activeFeedCategory = cat
      this.activeFeed = item

      this.editFeedForm.title = 'Edit Child of ' + cat.name
      this.editFeedForm.button = 'Save'
    },
    deleteFeed()
    {

    },
    savePersonPresets(presets)
    {
      this.settings.personPropertyPresets = presets

      this.saveTenant('Person presets saved')
    },
    saveTenant(successMessage)
    {
      ChiRhosNextApi.TenantApi.post(this.settings).then(
                response => {
                  this.$toast(successMessage, "success")
                },
                error => {
                  console.error(error)
                  error.json().then(body => {
                    this.$toast(body.Message, "error")
                  })
                }
              )
    },
    disclaimerSubmit(evt)
    {
      evt.preventDefault()

      this.saveTenant('Disclaimer saved')
    },

  },
}
</script>
